import { Filter } from '@empathy/search-types';
import { EmpathyXConfig, QuerySignalsState } from '../../../models';
import { Dictionary } from '../../../utils';
import { GETTERS_KEYS } from '../../store.const';
import { RootStoreState } from '../../store.interfaces';
import { QUERY_SIGNALS_GETTERS_KEYS } from '../query-signals.const';
import { QuerySignalsGetter } from '../query-signals.interfaces';

export class NextQueriesFiltersGetter implements QuerySignalsGetter {

  getters = {
    [QUERY_SIGNALS_GETTERS_KEYS.nextQueriesFilters]: (querySignalsState: QuerySignalsState, getters: any, rootState: RootStoreState,
      rootGetters: any): Dictionary<Filter[]> => {
      const { nextQueries: { facetsToApply } }: EmpathyXConfig = rootGetters[GETTERS_KEYS.config.config];
      const selectedRootFiltersByFacet: Dictionary<Filter[]> = rootGetters[GETTERS_KEYS.search.selectedRootFiltersByFacet];
      return facetsToApply.reduce<Dictionary<Filter[]>>((selectedFilters, facetName) => {
        if (selectedRootFiltersByFacet[facetName]) {
          selectedFilters[facetName] = selectedRootFiltersByFacet[facetName];
        }
        return selectedFilters;
      }, {});
    }
  };
}
